export default "__VITE_ASSET__0d40b1e7__"